import React, {Component, createRef} from "react";
import {Button, Card, CardBody, CardGroup, Col, Row} from "reactstrap";
import LoginImg from "../../../assets/img/login/login-background.jpg-v1.jpg";
import backImg from "../../../assets/img/signin/back-img.png";
import st_logo from "../../../assets/img/logos/smarttags_logo.png";
import CTLogo from "../../../assets/img/logos/ct_powerdby.png";
import './style.css';
import IntlTelInput from "react-intl-tel-input";
import button, {Checkbox, Input} from 'semantic-ui-react';
import OtpInput from "react-otp-input";
import Countdown from "react-countdown";
import * as util from "../../../util/Validator";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import * as common from "../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import axiosAuth from "../../../axios/axios_authorization";
import apiConfig from "../../../axios/axios_api_services";
import * as qs from "qs";
import * as keys from "../../../const/key/Key";
import axiosEventTags from "../../../axios/axios_eventtag";
import {DIALOG_PRIVACY_POLICY} from "../../../const/config/config";
import JWT_Decode from "jwt-decode";
import {SUB_EVENT_QR_UUID_PROFILE_ENABLE} from "../../../const/key/Key";
import SocialLogins from "../WebSignUp/SocialMediaBtn/SocialMediaBtn";

class Login extends Component {
  state = {
    userMobile: '',
    userMobile_: '',
    userPIN : '',
    validMobile: false,
    switch: false,
    date: Date.now() + 60000,
    isStaticEvent: false, isAgree: false
  }

  componentDidMount() {
    let eventId = new URLSearchParams(window.location.search).get('e');
    if (eventId) {
      sessionStorage.setItem(keys.SUB_EVENT_QR_UUID,eventId);
      // sessionStorage.setItem(keys.SUB_EVENT_QR_UUID_PROFILE_ENABLE, "0");
      let token = Cookies.get("68a6102f6ed24899420170004a0273b8");
      if (token !== undefined) {
        let decode_token = JWT_Decode(token);
        let USER_AUTHORITIES = decode_token && decode_token.authorities && decode_token.authorities.length > 0 ? decode_token.authorities[0] : null;
        if (USER_AUTHORITIES === 'ROLE_MOBILE_USER') this.props.history.push("/user/details");
      }
    }else{
      // sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
      // sessionStorage.setItem(keys.SUB_EVENT_QR_UUID_PROFILE_ENABLE, "1");
    }
  }

  onHandleChangeHostMobile = (condition, value, object, withdialcod) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcod.substr(1).replace(/\s/g, ""),condition);
    this.setState({
      validMobile:condition,
      userMobile:value,
      userMobile_: withdialcod.substr(1).replace(/\s/g, "")
    });
  };

  customPlaceholder = (selectedCountryPlaceholder) => {
    // return selectedCountryPlaceholder.substr(0,2) + "XXXXXXXX";
    return "7XXXXXXXX";
  };

  onSubmitToGetUser = () => {
    this.setState({switch:true});
  }

  onChangeSwitch = () => {
    this.setState({switch:false});
  }

  /*onHandleChange = name => e => {
    let value = e.target.value;
    console.log(value);
    switch (name) {
      case 'userPIN':
        this.setState({userPIN: value});
        break;
      default:
        break;
    }
  };*/

  onOTPChangeHandle = (otp) => {
    this.setState({userPIN:otp});

  }

  renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <a style={{marginBottom: '25px',borderBottom: '1px solid',color: '#7C3476'}} onClick={() => this.sendOTP()}>Resend Code</a>;
    } else {
      return <span style={{paddingBottom: '25px'}}>{`0${minutes}`}:{seconds > 9 ? seconds : `0${seconds}`}</span>;
    }
  }

  onCheckUserExist = () => {
    let {isAgree, validMobile} = this.state;
    if(!validMobile) return common.notifyMessage("Please enter valid mobile number")
    if(!isAgree) return common.notifyMessage("You must agree to the privacy policy statement")
    this.checkUserExist()
  }
  socialLoginData = (obj) => {
    console.log("obj",obj)
  }

  checkUserExist = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosAuth.get(apiConfig.CHECK_MOBILE_EXIST(this.state.userMobile_),{headers:headers})
      .then(response => {
        if (response.data.success) {
          this.sendOTP();
        } else {
            this.props.history.push('/public/web-sign-up',{mobile: this.state.userMobile_, tab: 2})
          /*} else {
            common.warningAlert(response.data.message)
            this.setState({validMobile:false, userMobile: '', userMobile_: ''})
          }*/
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {

        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  sendOTP = () => {
    this.props.spinnerHandler(true);
    const headers = {"Content-Type": "application/json"};
    axiosAuth.post(apiConfig.USER_SIGN_UP_SEND_OTP,{mobile:this.state.userMobile_}, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({date: Date.now() + 60000, userPIN:'', switch:true})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  onVerifyAndSignin = () => {
    this.state.userPIN !== '' ? this.verifyOTP() : common.notifyMessage("Please enter the otp")
  }

  verifyOTP = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Content-Type" : "application/json"
    }
    const data = JSON.stringify({"mobile" : this.state.userMobile_, "otp" : this.state.userPIN})
    axiosAuth.post(apiConfig.VERIFY_OTP,data,{headers:headers})
      .then(response => {
        if (response.data.success) {
          this.signInUserHandle()
        } else {
          common.warningAlert(response.data.message);
          this.setState({userPIN:''})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  signInUserHandle = () => {
    this.props.spinnerHandler(true);

    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization" : "Basic Y2V5ZW50cmE6"
    };

    const data = {
      username: this.state.userMobile_,
      password: this.state.userPIN,
      grant_type: 'password'
    }

    axiosAuth.post(apiConfig.OAUTH,qs.stringify(data),{headers:headers})
      .then(response => {
        if (response.status === 200) {
          Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token);
          Cookies.set('9b8558ba3f051677daf36ebfc67f29fa', response.data.refresh_token);
          this.props.spinnerHandler(false);
          this.props.history.push("/user/details");
        }
      })
      .catch(error => {
        this.props.spinnerHandler(false);
        if (error.status === 403) {
          common.notifyMessage(error.statusDesc, 0, 3);
        } else {
          common.notifyMessage("This PIN does not valid ", 0, 3);
        }
      });
  }

  render() {
    let {date, isAgree} = this.state;
    return (
      <div className={"app signIn-background"}>
        {/**/}
        <div>
          <Row className="justify-content-center_ signIn-content-wrapper">
            <div className={'img-wrapper'}>
              <img className={"blur-img"} src={LoginImg} alt={'.'} />
              <img className={"ori-img"} src={LoginImg} alt={'.'} />
            </div>
            <div className={"right-main-panel animated_bounceInLeft"}>
              <CardGroup style={{boxShadow: '0 30px 60px 0 rgba(0,0,0,0.3)'}}>
                <Card className="p-4_ sub-login-panel d-flex justify-content-space-between" style={{border: 'none',height: '100%'}}>
                  <div>
                    <div className={"text-center"}>
                      <img src={st_logo} alt={"."} className={"st-logo"}/>
                    </div>
                    {
                      !this.state.switch ?
                        <div className={'align-self-center p-3'}>
                          <h1>Login</h1>
                          <p className={'text-muted'}>Enter your mobile number and get PIN via SMS to sign in to
                            your account.</p>
                          <Row className={'align-items-center justify-content-center'}>
                            <div className={'display-inline'} style={{width: '60%'}}>
                              <IntlTelInput
                                style={{width: '100%', marginBottom: '10px'}}
                                type={"text"}
                                fieldName={"Mobile Number"}
                                value={this.state.userMobile}
                                containerClassName="intl-tel-input dashboard-intl"
                                inputClassName="form-control"
                                onPhoneNumberChange={this.onHandleChangeHostMobile}
                                required={true}
                                preferredCountries={['lk']}
                                defaultCountry={"lk"}
                                nationalMode={false}
                                icon='mobile alternate'
                                customPlaceholder={this.customPlaceholder}
                              />
                            </div>
                          </Row>
                          <div className={"check-box-wrapper align-center mt-4 mb-4"}>
                            <Checkbox onChange={() => this.setState({isAgree: !isAgree})} checked={isAgree} />
                            <label className={'ml-2 agree-txt-lbl'}>
                              <span className={"lng-eng"}>I agree to the <a href={DIALOG_PRIVACY_POLICY} target={"_blank"}>Privacy Policy</a></span>
                            </label>
                          </div>
                          <Row className={'align-items-center justify-content-center'}>
                            {/* <Col lg={8} md={8} xs={8} sm={8}>*/}
                            {/*<br/>*/}
                            <Button
                              onClick={this.onCheckUserExist}
                              className="submit-btn"
                            >Send PIN via SMS
                            </Button>
                            {/*</Col>*/}
                          </Row>
                          {/*<Row>*/}
                          {/*  <Col md={12} className={'social-login-content'}>*/}
                          {/*    <SocialLogins isHideApple={true} setData={this.socialLoginData} type={'sign-up'}/>*/}
                          {/*  </Col>*/}
                          {/*</Row>*/}
                          <Row className={'align-items-center justify-content-center downloadApp-WebView'}>
                            <Col md={12} className={'d-flex align-items-end justify-content-center'}>
                              <p className="text-center download-text">For an amazing experience, download the app today!
                              </p>
                            </Col>
                            <Col md={12} className={'d-flex align-items-start justify-content-center'}>
                              <a className="apps-btn wrap-1" role="button"
                                 href={keys.SMART_APP_PLAY_STORE_APP} target={"_blank"}>
                                <img src="/app-assets/play-store-badge.png" alt="play-store-badge"/>
                              </a>
                              <a className="apps-btn wrap-1" role="button"
                                 href={keys.SMART_APP_APP_STORE_APP} target={"_blank"}>
                                <img src="/app-assets/app-store-badge.svg" alt="app-store-badge"/>
                              </a>
                            </Col>
                          </Row>
                        </div> :
                        <CardBody className={'align-self-center'}>
                          {/*<Row className={'p-3 align-items-center'}>
                        <button className="ui icon button back-btn" onClick={this.onChangeSwitch}>
                          <i className="angle left icon back-btn-icon"></i>
                        </button>
                          <label className={'back-btn-label'}>Change Mobile</label>
                        </Row>*/}
                          <div className={"back-icon-wrapper"} onClick={this.onChangeSwitch}>
                            <img src={backImg} alt={"back-icon"} />
                          </div>
                          <p className="text-muted p-3">We sent a SMS to {this.state.userMobile} with PIN. Enter PIN you
                            received to sign in to your account.</p>
                          <Row className={'align-items-center justify-content-center'}>
                            <div className={'display-inline flex-column align-items-center'}>
                              <OtpInput
                                shouldAutoFocus={true}
                                value={this.state.userPIN}
                                onChange={this.onOTPChangeHandle}
                                numInputs={5}
                                // separator={<span>{"-"}</span>}
                                // isInputNum={true}
                                inputType={"tel"}
                                // focusStyle="otpInputFocus"
                                inputStyle={{margin:'0 10px 20px', width:'2.5em'}}
                                containerStyle={{justifyContent:'center'}}
                                // focusStyle={{border: '1px solid #FFAD33!important'}}
                                renderInput={(props) => <input {...props} />}
                              />
                              <Countdown key={date} date={date} renderer={this.renderer}/>
                            </div>
                          </Row>
                          <Row className={'align-items-center justify-content-center'}>
                            <Button
                              onClick={this.onVerifyAndSignin}
                              className="submit-btn"
                            >Verify & Sign in
                            </Button>
                          </Row>

                        </CardBody>
                    }
                  </div>
                  <div>
                    {!this.state.switch && <Row className={'download-app-sec align-items-center justify-content-center'}>
                      <Col className={'d-flex align-items-end justify-content-center'}>
                        <p className="text-center download-text">For an amazing experience, download the app today!
                        </p>
                      </Col>
                      <Col className={'d-flex align-items-start justify-content-center'}>
                        <a className="apps-btn wrap-1" role="button"
                           href={keys.SMART_APP_PLAY_STORE_APP} target={"_blank"}>
                          <img src="/app-assets/play-store-badge.png" alt="play-store-badge"/>
                        </a>
                        <a className="apps-btn wrap-1" role="button"
                           href={keys.SMART_APP_APP_STORE_APP} target={"_blank"}>
                          <img src="/app-assets/app-store-badge.svg" alt="app-store-badge"/>
                        </a>
                      </Col>
                    </Row>}
                    <div className={"text-center ct-bottom-logo-wrapper"}>
                      {/*href={"https://ceyentra.com/"}*/}
                      <a target="_blank" href={"https://ceyentra.com/"}><img src={CTLogo} alt={"."} className={"ct-bottom-logo"}/></a>
                    </div>
                  </div>
                </Card>
              </CardGroup>
            </div>
          </Row>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
  };
};

export default connect(null, mapDispatchToProps)(Login);
